<template>
  <div style="height: 100%;">
    <div style="margin: 0 0.75rem 0.75rem;">
      <p class="title is-4" style="font-weight: 700;">Kontak</p>

      <form @submit.prevent="getContacts">
        <div class="field">
          <div class="control has-icons-left">
            <input class="input" type="text" placeholder="Cari kontak..." v-model="search_contact">
            <span class="icon is-small is-left">
              <i class="fas fa-search"></i>
            </span>
          </div>
        </div>
      </form>
    </div>

  	<aside class="menu" style="height: calc(66vh - 4px);">
      <ul class="menu-list" style="margin: 0; list-style: none; overflow: auto; height: 100%;">
        <li v-if="loading_get_contacts_refresh && !loading_get_contacts"><spinner-loading></spinner-loading></li>
        <li v-if="!loading_get_contacts_refresh && !isEmpty(contacts)" style="border-bottom: 1px solid #e3e3e3;" v-for="(c,i) in contacts" :key="i">
        	<a href="" @click.prevent="newConversation(c.id)">
        		<div class="columns is-mobile is-vcentered">
        			<div class="column is-narrow">
                <figure class="image is-42x42 is-circle">
                  <avatar v-if="c.isAdminPt" :avatar_url="!isEmpty(c.avatar) ? c.avatar : '/assets/img/default-male.png'" inputStyle="box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08); max-height: none;"></avatar>
                  <avatar v-else :avatar_url="!isEmpty(c.avatar) ? c.avatar : '/assets/img/default-male.png'" inputStyle="box-shadow: 0 4px 6px rgba(50,50,93,.11), 0 1px 3px rgba(0,0,0,.08); max-height: none;"></avatar>
                </figure>
              </div>
        			<div class="column truncated-text" style="padding-left: 0;">
        				<p class="title font-14"><span class="font-w-600">{{ c.name || '-' }}</span> <span class="tag is-lightyellow font-12" v-if="c.isAdminPt"><small>Admin</small></span></p>
        				<p class="subtitle font-12 has-text-grey" style="font-size: 15px; margin-bottom: 7px;">{{ c.email || '-' }}</p>
        			</div>
        		</div>
        	</a>
        </li>
        <li v-if="!loading_get_contacts && !loading_get_contacts_refresh && !isEmpty(contacts)">
          <br/>
          <pagination :dataProvider="contactDataProvider" :clickHandler="getContacts"></pagination>
          <br/>
        </li>
        <li v-if="!loading_get_contacts_refresh && loading_get_contacts"><spinner-loading></spinner-loading></li>
        <li v-if="!loading_get_contacts_refresh && !loading_get_contacts && isEmpty(contacts)">
          <p class="has-text-centered has-text-grey">Tidak ada kontak.</p>
        </li>
      </ul>
    </aside>
  </div>
</template>

<script>
import { CONVERSATION } from '~/consts'
import USER_MIXIN from '~/mixins/user'

export default {
  mixins: [USER_MIXIN],

  props: {
    newConversation: {
      type: Function,
      default: () => {}
    }
  },

  mounted() {
    this.getContacts(true)
  },

  data() {
    return {
      contacts: [],
    }
  },

  methods: {
    onGetPaginatedContactsSuccess(contacts) {
      this.contacts = contacts
    }
  }
}
</script>
